import React, { useState, useRef, useEffect } from "react";
import { CATEGORY, endpoints } from "../../../api/endpoints";
import { MdOutlineEmail } from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";
import {
  FLOOR_AREA_JASON,
  FRANCHISE_MODEL,
  INTERNET_CONNECTION,
  INVESTMENT_RANGE,
} from "../../../utils/Utils";
import {
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import Api_Instance from "../../../api/Api_Instance";
import toast from "react-hot-toast";
import CountriesApi from "../../../common/countriesapi/CountriesApi";
import SelectBox from "../../../common/selectbox/SelectBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { emailRegex, urlRegex, emojiRegex } from "../../../CommonExport";
import { useSelector } from "react-redux";

function Franchisor() {
  const unAuth = Api_Instance.unAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [selectedModels, setSelectedModels] = useState([]);
  const [countrydata, setCountrydata] = useState({
    countryid: "",
    stateid: "",
    cityid: "",
  });
  const advertisementData = useSelector((state) => state?.auth?.advertisement_data)
  const [formValues, setFormValues] = useState({
    user: "",
    email: "",
    password: "",
    brand_name: "",
    category: "",
    franchise_tagline: "",
    establish_year: "",
    franchise_start: "",
    mobile_number: "",
    brand_outlet: "",
    franchise_model: "",
    investment: "",
    franchise_fees: "",
    equipments: "",
    franchise_fixture: "",
    advertising_marketing: "",
    expected_pay_back_period: "",
    expansion_areas: "",
    return_on_investment: "",
    required_area: "",
    required_property: "",
    location: "",
    internet_connection: "",
    computer_system: "",
    staff_required: "",
    field_assistance: "",
    training_programme: "",
    detailed_operating: "",
    it_system: "",
    website: "",
    country: "",
    state: "",
    city: "",
    franchise_term: "",
    brand_agreement: "yes",
    master_franchise: "no",
    business_overview: "",
    upload_logo: "",
    upload_banner: "",
    terms_conditions: false,
    direct_lead: true,
  });
  const [categorydata, setCategoryData] = useState([]);
  const signupvalues = {
    email: formValues.email,
    password: formValues.password,
    role: "franchiser",
  };
  const [errors, setErrors] = useState({});
  const currentDate = new Date().toISOString().split("T")[0]; // Today's date in YYYY-MM-DD format
  const minDate = "1950-01-01";
  const handleChange = (e, typeOfUploading) => {
    const { name, value, checked, files } = e.target;

    if (files && files.length > 0) {
      // Define file size limits in KB
      const fileSizeLimit = typeOfUploading === "logo" ? 20 : 500; // Logo: 20 KB, Banner: 500 KB
      const allowedFileTypes = ["png", "jpeg", "jpg", "webp"];
      const file = files[0];

      const fileSizeInKB = file.size / 1024;
      const fileExtension = file.name.split(".").pop().toLowerCase();

      // File size validation
      if (fileSizeInKB > fileSizeLimit) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: `File size must not exceed ${fileSizeLimit} KB`,
        }));
        return;
      }
      // File type validation
      if (!allowedFileTypes.includes(fileExtension)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: `Invalid file type. Only ${allowedFileTypes.join(", ")} files are allowed.`,
        }));
        return;
      }

      // Clear errors and update form values for valid files
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
      setFormValues((prevValues) => ({
        ...prevValues,
        [name]: file,
      }));
    } else {
      // Handle checkboxes
      if (e.target.type === "checkbox") {
        setFormValues((prevValues) => ({
          ...prevValues,
          [name]: checked,
        }));

        // Validate checkboxes if needed
        const fieldError =
          name === "terms_conditions" && !checked
            ? "Please agree to the Terms & Conditions."
            : "";
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: fieldError,
        }));
      } else {
        // Handle other fields
        setFormValues((prevValues) => ({
          ...prevValues,
          [name]: value,
        }));
        // Validate other fields
        const fieldError = validate({ [name]: value })[name];
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: fieldError,
        }));
        // Validation logic

        if (name === "franchise_start" && formValues.establish_year) {
          if (value < formValues.establish_year) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              franchise_start:
                "Franchise Start Year cannot be earlier than Established Year.",
            }));
          } else {
            setErrors((prevErrors) => ({ ...prevErrors, franchise_start: "" }));
          }
        }

        if (name === "establish_year" && formValues.franchise_start) {
          if (formValues.franchise_start < value) {
            setErrors((prevErrors) => ({
              ...prevErrors,
              franchise_start:
                "Franchise Start Year cannot be earlier than Established Year.",
            }));
          } else {
            setErrors((prevErrors) => ({ ...prevErrors, franchise_start: "" }));
          }
        }

      }
    }
  };
  const { useCountries, States, Ctiy } = CountriesApi;
  const { countries } = useCountries();
  const { statedata } = States(countrydata.countryid);
  const { citydata } = Ctiy(countrydata.stateid);
  const initialFormValues = {
    user: "",
    email: "",
    password: "",
    brand_name: "",
    category: "",
    franchise_tagline: "",
    establish_year: "",
    franchise_start: "",
    mobile_number: "",
    brand_outlet: "",
    franchise_model: "",
    investment: "",
    franchise_fees: "",
    equipments: "",
    franchise_fixture: "",
    advertising_marketing: "",
    expected_pay_back_period: "",
    expansion_areas: "",
    return_on_investment: "",
    required_area: "",
    required_property: "",
    location: "",
    internet_connection: "",
    computer_system: "",
    staff_required: "",
    field_assistance: "",
    training_programme: "",
    detailed_operating: "",
    it_system: "",
    website: "",
    country: "",
    state: "",
    city: "",
    franchise_term: "",
    brand_agreement: "yes",
    master_franchise: "no",
    business_overview: "",
    upload_logo: "",
    upload_banner: "",
    direct_lead: true,
  };
  const handleCountryChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selectedCountryName = options[selectedIndex].text;
    setFormValues((prevValues) => ({
      ...prevValues,
      country: value,
    }));
    setCountrydata((prev) => ({
      ...prev,
      countryid: selectedIndex - 1,
    }));
  };
  useEffect(() => {
    setFormValues((prev) => ({
      ...prev,
      upload_logo: "",
      upload_banner: "",
    }))
  }, [])
  const handleStateChange = (event) => {
    const { value, options, selectedIndex } = event.target;
    const selected_id = options[selectedIndex].getAttribute("data-id");
    setFormValues((prevValues) => ({
      ...prevValues,
      state: value,
    }));
    setCountrydata((prev) => ({
      ...prev,
      stateid: selected_id,
    }));
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const fieldError = validate({ [name]: value })[name];
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError,
    }));
  };

  const signUp = async () => {

    try {
      const response = await unAuth("POST", endpoints.SIGNUP_API, signupvalues);
      setFormValues(initialFormValues)
      if (response.data.message) {
        toast.success(response.data.message);
      }
      return response?.data?.data?.user_id;
    } catch (error) {
      const errorResponse = error.response?.data;
      if (errorResponse) {
        toast.error(errorResponse.message || "An error occurred");
      } else {
        toast.error(error.message || "An unknown error occurred");
      }
    }
  };

  const businessvalues = {};
  for (const prop in formValues) {
    if (prop === "email" || prop === "password") {
      businessvalues[prop] = "";
    } else if (prop === "establish_year") {
      const date = new Date(formValues[prop]);
      businessvalues[prop] = date.getFullYear().toString();
    } else if (prop === "franchise_start") {
      const date = new Date(formValues[prop]);
      businessvalues[prop] = date.getFullYear().toString();
    } else {
      businessvalues[prop] = formValues[prop];
    }
  }
  const bussinessDetails = async (id) => {
    const data = new FormData();
    for (const key in businessvalues) {
      if (key === "user") {
        data.append(key, id);
      } else if (key === "franchise_model") {
        data.append(key, selectedModels);
      } else {
        data.append(key, businessvalues[key]);
      }
    }
    try {
      const response = await unAuth("POST", endpoints.BUSSINESS_API, data);

      if (response.data.message) {
        toast.success(response.data.message);
        setFormValues(initialFormValues)
        window.location.reload()
      }
    } catch (error) {

    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formValues);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const res = await signUp();
      await bussinessDetails(res);
    }
  };
  const validateAlphabets = (value) => {
    const alphabetPattern = /^[a-zA-Z\s]*$/;
    return alphabetPattern.test(value);
  };

  const validate = (values) => {
    const errors = {};
    const requiredFields = [
      "email",
      "password",
      "brand_name",
      "category",
      "franchise_tagline",
      "establish_year",
      "franchise_start",
      "mobile_number",
      "brand_outlet",
      "investment",
      "franchise_fees",
      "equipments",
      "franchise_fixture",
      "advertising_marketing",
      "expected_pay_back_period",
      "expansion_areas",
      "return_on_investment",
      "required_property",
      "required_area",
      "location",
      "internet_connection",
      "computer_system",
      "staff_required",
      "field_assistance",
      "training_programme",
      "detailed_operating",
      "it_system",
      "website",
      "country",
      "state",
      "city",
      "franchise_term",
      "brand_agreement",
      "master_franchise",
      "business_overview",
      "upload_logo",
      "upload_banner",
    ];
    const specialCharacterPattern = /[^a-zA-Z0-9\s]/;
    const websitePattern = /\.(com|in)$/;
    const formatFieldName = (field) => {
      return field
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
    };

    requiredFields.forEach((field) => {
      const value = values[field];

      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim()) ||
        (value instanceof File && !value.name)
      ) {
        const displayName = field === "staff_required" ? "Staff" : formatFieldName(field);
        errors[field] = `${displayName} is required`;
      } else if (
        field !== "email" &&
        field !== "establish_year" &&
        field !== "franchise_start" &&
        field !== "investment" &&
        field !== "password" &&
        field !== "website" &&
        field !== "country" &&
        field !== "state" &&
        field !== "city" &&
        field !== "upload_logo" &&
        field !== "business_overview" &&
        field !== "upload_banner" &&
        field !== "brand_outlet" &&
        specialCharacterPattern.test(value)
      ) {
        // errors[field] = `${formatFieldName(field)} contains invalid characters`;
      } else if (field === "required_property" && !validateAlphabets(value)) {
        errors[field] = `${formatFieldName(field)} must contain only alphabets`;
      } else if (field === "website" && !websitePattern.test(value)) {
        errors[field] = `${formatFieldName(field)} must end with .com or .in`;
      }
    });
    // Validate upload_logo
    if (!values.upload_logo) {
      errors.upload_logo = "Upload Logo is required";
    } else if (values.upload_logo.size > 20 * 1024) {
      errors.upload_logo = "Logo file size must not exceed 20 KB";
    } else if (values.upload_logo?.type == "application/pdf") {
      errors.upload_logo = "Logo file  not accept pdf type";
    }

    // Validate upload_banner
    if (!values.upload_banner) {
      errors.upload_banner = "Upload Banner is required";
    } else if (values.upload_banner.size > 500 * 1024) {
      errors.upload_banner = "Banner file size must not exceed 500 KB";
    } else if (values.upload_banner?.type == "application/pdf") {
      errors.upload_banner = "Banner file not accept pdf type";
    }

    if (values.franchise_term) {
      if (values.franchise_term.length < 10) {
        errors.franchise_term = "Franchise Term must be at least 10 characters";
      } else if (values.franchise_term.length > 200) {
        errors.franchise_term = "Franchise Term not exceeds more than 200 characters";
      }
    }

    const multipleDomainsPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+\.[^\s@]+$/;
    if (!urlRegex.test(values.website)) {
      errors.website = "Please Enter a Valid Website Name";
    }

    if (values.email) {
      const trimmedEmail = values.email.trim();
      if (
        !emailRegex.test(trimmedEmail) ||
        multipleDomainsPattern.test(trimmedEmail) ||
        emojiRegex.test(trimmedEmail)
      ) {
        errors.email = "Email address is invalid";
      }
    }

    if (values.password && values.password.length < 8) {
      errors.password = "Password must be at least 8 characters";
    }

    if (!values.establish_year) {
      errors.establish_year = "Established year is required";
    } else if (
      values.establish_year < 1800 ||
      values.establish_year > new Date().getFullYear()
    ) {
      errors.establish_year = "Established year must be between 1800 and the current year";
    }

    if (!values.franchise_start) {
      errors.franchise_start = "Franchise start year is required";
    } else if (
      values.franchise_start < 1800 ||
      values.franchise_start > new Date().getFullYear()
    ) {
      errors.franchise_start = "Franchise start year must be between 1800 and the current year";
    }

    if (values.mobile_number && !/^[6-9]\d{9}$/.test(values.mobile_number)) {
      errors.mobile_number = "Mobile number is invalid";
    }

    if (!formValues?.terms_conditions) {
      errors.terms_conditions = "Please agree to the Terms & Conditions."
    }
    if (selectedModels.length == 0) {
      errors.franchise_model = "Please select franchise model"
    }
    return errors;
  };


  const cateGoryApi = async () => {
    try {
      const res = await unAuth("GET", CATEGORY.GET_CATEGORY);
      setCategoryData(res?.data?.data);
    } catch (error) { }
  };



  useEffect(() => {
    cateGoryApi();
  }, [formValues.user]);
  useEffect(() => {
    if (selectedModels.length) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        franchise_model: "",
      }));
    }
  }, [selectedModels]);

  const handleSelect = (value) => {
    if (!selectedModels.includes(value)) {
      setSelectedModels([...selectedModels, value]);
    }
  };

  const handleRemove = (model) => {
    setSelectedModels(selectedModels.filter((m) => m !== model));
  };

  return (
    <div className="w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
      <div className="flex items-start justify-between mt-8">
        <div className="flex-[0_0_75%] ">
          <div className=" bg-[#f9f8f8] [box-shadow:inset_0_0px_0px_rgba(0,_0,_0,_.075),_0_0_0px_rgb(0_0_0_/_20%)] p-3 lg:p-0  p-8 rounded-lg w-full mx-auto">
            <form onSubmit={handleSubmit}>
              {/* Login Details */}
              <div className="mb-8">
                <h3 className="text-2xl font-lg text-text_color mt-3 font-semibold border-b border-[#b9b9b9] pb-2 mb-4">
                  Login Details
                </h3>
                <div className="flex flex-col md:flex-row gap-4 mt-3">
                  <div className="flex-1">
                    <label htmlFor="email" className="mb-1 font-md block font-semibold capitalize">
                      Email <span className="text-star_color">*</span>
                    </label>
                    <div className="!border-[1px] !border-[solid] !border-[#ccc] !text-[12px] [box-shadow:inset_0_5px_5px_0_rgba(0,_0,_0,_.05)] flex items-center rounded">
                      <div className="">
                        <MdOutlineEmail className="text-[20px] mx-2" />

                      </div>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formValues.email}
                        onChange={(e) => handleChange(e, "other")}
                        onBlur={handleBlur}
                        placeholder="Enter Email"
                        maxLength={25}
                        className="p-2 border border-gray-300 w-full focus:outline-none"
                      />
                    </div>
                    {errors.email && (
                      <p className="text-star_color text-sm">{errors.email}</p>
                    )}
                  </div>
                  <div className="flex-1 relative">
                    <label htmlFor="password" className="mb-1 font-md block font-semibold capitalize">
                      Password <span className="text-star_color">*</span>
                    </label>
                    <div className="!border-[1px] !border-[solid] !border-[#ccc] !text-[12px] [box-shadow:inset_0_5px_5px_0_rgba(0,_0,_0,_.05)] flex items-center rounded">
                      <div>
                        <RiLockPasswordFill className="text-[20px] mx-2" />
                      </div>
                      <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        value={formValues.password}
                        onChange={(e) => handleChange(e, "other")}
                        placeholder="Enter Password"
                        className=" p-2 border border-gray-300 w-full focus:outline-none"
                        maxLength={25}
                      />
                    </div>
                    <button
                      type="button"
                      className="absolute top-[36px] right-[10px] text-gray-500"
                      onClick={() => setShowPassword((prev) => !prev)}
                    >
                      <FontAwesomeIcon
                        icon={showPassword ? faEyeSlash : faEye}
                        size="sm"
                      />
                    </button>
                    {errors.password && (
                      <p className="text-star_color text-sm">{errors.password}</p>
                    )}
                  </div>
                </div>
              </div>

              {/* Business Details */}
              <div className="mb-8">
                <h3 className="text-2xl font-lg text-text_color font-semibold border-b border-[#b9b9b9] pb-2 mb-3">
                  Business Details
                </h3>
                <div className="flex flex-col md:flex-row gap-4 mt-3">
                  <div className="flex-1">
                    <label htmlFor="brand_name" className="mb-1 font-md block font-semibold capitalize">
                      Brand Name <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="text"
                      id="brand_name"
                      name="brand_name"
                      value={formValues.brand_name}
                      onChange={(e) => handleChange(e, "other")}
                      placeholder="Enter Brand Name"
                      className="p-2 border border-gray-300 rounded w-full"
                    />
                    {errors.brand_name && (
                      <p className="text-star_color text-sm">{errors.brand_name}</p>
                    )}
                  </div>
                  <div className="flex-1 relative">
                    <label htmlFor="category" className="mb-1 font-md block font-semibold capitalize">
                      Category <span className="text-star_color">*</span>
                    </label>
                    <select
                      id="category"
                      name="category"
                      value={formValues.category}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      className="form-select p-2 border border-gray-300 rounded w-full"
                    >
                      <option value="" disabled>
                        Category
                      </option>
                      {categorydata?.map((item) => (
                        <option value={item?.id}>{item?.name}</option>
                      ))}
                    </select>
                    {errors.category && (
                      <p className="text-star_color text-sm">{errors.category}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="relative">
                  <label htmlFor="franchise_tagline" className="mb-1 font-md block font-semibold capitalize">
                    Franchise Tagline <span className="text-star_color">*</span>
                  </label>
                  <input
                    type="text"
                    id="franchise_tagline"
                    name="franchise_tagline"
                    value={formValues.franchise_tagline}
                    onChange={(e) => handleChange(e, "other")}
                    placeholder="Enter Franchise Tagline"
                    className="p-2 border border-gray-300 rounded w-full"
                  />

                  {errors.franchise_tagline && (
                    <p className="text-star_color text-sm">
                      {errors.franchise_tagline}
                    </p>
                  )}
                </div>
                <div className="relative">
                  <label htmlFor="establish_year" className="mb-1 font-md block font-semibold capitalize">
                    Established Year <span className="text-star_color">*</span>
                  </label>
                  <input
                    type="date"
                    id="establish_year"
                    name="establish_year"
                    value={formValues.establish_year}
                    onChange={(e) => handleChange(e, "other")}
                    min={minDate} // Set minimum date to 1950-01-01
                    max={currentDate} // Set maximum date to today's date
                    className="p-2 border border-gray-300 rounded w-full"
                    placeholder="Select Established Date"
                  />

                  {errors.establish_year && (
                    <p className="text-star_color text-sm">
                      {errors.establish_year}
                    </p>
                  )}
                </div>

                <div className="relative">
                  <label htmlFor="franchise_start" className="mb-1 font-md block font-semibold capitalize">
                    Franchise Start Year <span className="text-star_color">*</span>
                  </label>
                  <input
                    type="date"
                    id="franchise_start"
                    name="franchise_start"
                    value={formValues.franchise_start}
                    onChange={(e) => handleChange(e, "other")}
                    min={formValues.establish_year || minDate} // Minimum date depends on Established Year
                    max={currentDate}
                    className="p-2 border border-gray-300 rounded w-full"
                    placeholder="Select Franchise Start Date"
                  />
                  {errors.franchise_start && (
                    <p className="text-star_color text-sm">
                      {errors.franchise_start}
                    </p>
                  )}
                </div>
                <SelectBox
                  options={FRANCHISE_MODEL}
                  selectedOptions={selectedModels}
                  onChange={handleSelect}
                  onRemove={handleRemove}
                  error={errors.franchise_model}
                />
                <div>
                  <label htmlFor="mobile_number" className="mb-1 font-md block font-semibold capitalize">
                    Mobile No <span className="text-star_color">*</span>
                  </label>
                  <input
                    type="text"
                    id="mobile_number"
                    name="mobile_number"
                    value={formValues.mobile_number}
                    onChange={(e) => handleChange(e, "other")}
                    placeholder="Enter Mobile No"
                    className="p-2 border border-gray-300 rounded w-full"
                  />
                  {errors.mobile_number && (
                    <p className="text-star_color text-sm">
                      {errors.mobile_number}
                    </p>
                  )}
                </div>
                <div className="relative">
                  <label htmlFor="brand_outlet" className="mb-1 font-md block font-semibold capitalize">
                    Brand Outlets <span className="text-star_color">*</span>
                  </label>
                  <select
                    id="brand_outlet"
                    name="brand_outlet"
                    value={formValues.brand_outlet}
                    onChange={(e) => handleChange(e, "other")}
                    className="form-select p-2 border border-gray-300 rounded w-full"
                  >
                    <option value="" disabled>
                      Select Brand Outlets
                    </option>
                    <option value="+5">+5</option>
                    <option value="+10">+10</option>
                    <option value="+15">+15</option>
                    <option value="+20">+20</option>
                    <option value="+25">+25</option>
                    <option value="+100">+100</option>
                  </select>

                  {errors.brand_outlet && (
                    <p className="text-star_color text-sm">{errors.brand_outlet}</p>
                  )}
                </div>



              </div>
              {/* Brand investment Requirements */}
              <div className="mb-8 mt-5">
                <h3 className="text-2xl font-lg text-text_color mt-3 font-semibold border-b border-[#b9b9b9] pb-2 mb-4">
                  Brand investment Requirements
                </h3>
                <div className="flex flex-col md:flex-row gap-4 mt-3">
                  <div className="flex-1">
                    <label htmlFor="investment" className="mb-1 font-md block font-semibold capitalize">
                      Investment <span className="text-star_color">*</span>
                    </label>
                    <select
                      id="investment"
                      name="investment"
                      value={formValues.investment}
                      onChange={(e) => handleChange(e, "other")}
                      className=" form-select p-2 border border-gray-300 rounded w-full"
                    >
                      <option value="" disabled>
                        Investment
                      </option>
                      {INVESTMENT_RANGE.map((item) => (
                        <option value={item.value}>{item.label}</option>
                      ))}
                    </select>

                    {errors.investment && (
                      <p className="text-star_color text-sm">{errors.investment}</p>
                    )}
                  </div>
                  <div className="flex-1">
                    <label htmlFor="franchise_fees" className="mb-1 font-md block font-semibold capitalize">
                      Franchise Fee <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="text"
                      id="franchise_fees"
                      name="franchise_fees"
                      value={formValues.franchise_fees}
                      onChange={(e) => handleChange(e, "other")}
                      placeholder="Enter Franchise Fee"
                      className="p-2 border border-gray-300 rounded w-full"
                    />
                    {errors.franchise_fees && (
                      <p className="text-star_color text-sm">
                        {errors.franchise_fees}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="equipments" className="mb-1 font-md block font-semibold capitalize">
                    Equipments <span className="text-star_color">*</span>
                  </label>
                  <input
                    type="text"
                    id="equipments"
                    name="equipments"
                    value={formValues.equipments}
                    onChange={(e) => handleChange(e, "other")}
                    placeholder="Enter equipments"
                    className="p-2 border border-gray-300 rounded w-full"
                  />
                  {errors.equipments && (
                    <p className="text-star_color text-sm">{errors.equipments}</p>
                  )}
                </div>
                <div className="relative">
                  <label htmlFor="FurnitureFixture" className="mb-1 font-md block font-semibold capitalize">
                    Furniture and Fixture <span className="text-star_color">*</span>
                  </label>
                  <input
                    type="text"
                    id="FurnitureFixture"
                    name="franchise_fixture"
                    value={formValues.franchise_fixture}
                    onChange={(e) => handleChange(e, "other")}
                    placeholder="Enter Furniture and Fixture"
                    className="p-2 border border-gray-300 rounded w-full"
                  />

                  {errors.franchise_fixture && (
                    <p className="text-star_color text-sm">
                      {errors.franchise_fixture}
                    </p>
                  )}
                </div>
                <div>
                  <label
                    htmlFor="AdvertisingMarketing"
                    className="mb-1 font-md block font-semibold capitalize"
                  >
                    Advertising and Marketing{" "}
                    <span className="text-star_color">*</span>
                  </label>
                  <input
                    type="text"
                    id="AdvertisingMarketing"
                    name="advertising_marketing"
                    value={formValues.advertising_marketing}
                    onChange={(e) => handleChange(e, "other")}
                    placeholder="Enter Advertising and Marketing"
                    className="p-2 border border-gray-300 rounded w-full"
                  />
                  {errors.advertising_marketing && (
                    <p className="text-star_color text-sm">
                      {errors.advertising_marketing}
                    </p>
                  )}
                </div>
                <div className="relative">
                  <label
                    htmlFor="expected_pay_back_period"
                    className="mb-1 font-md block font-semibold capitalize"
                  >
                    Expected Pay Back Period
                    <span className="text-star_color">*</span>
                  </label>
                  <input
                    type="text"
                    id="expected_pay_back_period"
                    name="expected_pay_back_period"
                    value={formValues.expected_pay_back_period}
                    onChange={(e) => handleChange(e, "other")}
                    placeholder="Enter Expected Pay Back Period"
                    className="p-2 border border-gray-300 rounded w-full"
                  />

                  {errors.expected_pay_back_period && (
                    <p className="text-star_color text-sm">
                      {errors.expected_pay_back_period}
                    </p>
                  )}
                </div>
                <div>
                  <label htmlFor="expansion_areas" className="mb-1 font-md block font-semibold capitalize">
                    Looking Expansion in Areas{" "}
                    <span className="text-star_color">*</span>
                  </label>
                  <input
                    type="text"
                    id="expansion_areas"
                    name="expansion_areas"
                    value={formValues.expansion_areas}
                    onChange={(e) => handleChange(e, "other")}
                    placeholder="Enter Looking Expansion in Areas"
                    className="p-2 border border-gray-300 rounded w-full"
                  />
                  {errors.expansion_areas && (
                    <p className="text-star_color text-sm">
                      {errors.expansion_areas}
                    </p>
                  )}
                </div>
                <div className="">
                  <label
                    htmlFor="return_on_investment"
                    className="mb-1 font-md block font-semibold capitalize "
                  >
                    Return On nvestment (ROI){" "}
                    <span className="text-star_color">*</span>
                  </label>
                  <input
                    type="text"
                    id="return_on_investment"
                    name="return_on_investment"
                    value={formValues.return_on_investment}
                    onChange={(e) => handleChange(e, "other")}
                    placeholder="Enter Return on investment (ROI)"
                    className="p-2 border border-gray-300 rounded w-full"
                  />

                  {errors.return_on_investment && (
                    <p className="text-star_color text-sm">
                      {errors.return_on_investment}
                    </p>
                  )}
                </div>
              </div>

              {/* Brand Property Detail */}
              <div className="mb-8 mt-5">
                <h3 className="text-2xl font-lg text-text_color mt-3 font-semibold border-b border-[#b9b9b9] pb-2 mb-4">
                  Brand Property Detail
                </h3>
                <div className="flex flex-col md:flex-row gap-4 mt-3">
                  <div className="flex-1">
                    <label
                      htmlFor="required_property"
                      className="mb-1 font-md block font-semibold capitalize"
                    >
                      Required Property for this Brand Opportunity
                      <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="text"
                      id="required_property"
                      name="required_property"
                      value={formValues.required_property}
                      onChange={(e) => handleChange(e, "other")}
                      placeholder="Enter Required Property for this Brand Opportunity"
                      className="p-2 border border-gray-300 rounded w-full"
                    />
                    {errors.required_property && (
                      <p className="text-star_color text-sm">
                        {errors.required_property}
                      </p>
                    )}
                  </div>
                  <div className="flex-1">
                    <label htmlFor="required_area" className="mb-1 font-md block font-semibold capitalize">
                      Required Floor Area <span className="text-star_color">*</span>
                    </label>
                    {/* <input
                      type="text"
                      id="required_area"
                      name="required_area"
                      value={formValues.required_area}
                      onChange={(e) => handleChange(e, "other")}
                      placeholder="Enter required area"
                      className="p-2 border border-gray-300 rounded w-full"
                    /> */}
                    <select
                      id="required_area"
                      name="required_area"
                      value={formValues.required_area}
                      onChange={(e) => handleChange(e, "other")}
                      className="form-select p-2 border border-gray-300 rounded w-full"
                    >
                      <option value="" disabled>
                        Required Floor Area
                      </option>
                      {FLOOR_AREA_JASON?.map((item) => (
                        <option value={item.label}>{item.value}</option>
                      ))}
                    </select>
                    {errors.required_area && (
                      <p className="text-star_color text-sm">
                        {errors.required_area}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="location" className="mb-1 font-md block font-semibold capitalize">
                    Preferred Location for Franchise{" "}
                    <span className="text-star_color">*</span>
                  </label>
                  <input
                    type="text"
                    id="location"
                    name="location"
                    value={formValues.location}
                    onChange={(e) => handleChange(e, "other")}
                    placeholder="Enter Preferred Location for Franchise"
                    className="p-2 border border-gray-300 rounded w-full"
                  />
                  {errors.location && (
                    <p className="text-star_color text-sm">{errors.location}</p>
                  )}
                </div>
                <div className="relative">
                  <label
                    htmlFor="internet_connection"
                    className="mb-1 font-md block font-semibold capitalize"
                  >
                    Internet Connection <span className="text-star_color">*</span>
                  </label>
                  <select
                    id="internet_connection"
                    name="internet_connection"
                    value={formValues.internet_connection}
                    onChange={(e) => handleChange(e, "other")}
                    className="form-select p-2 border border-gray-300 rounded w-full form-select"
                  >
                    <option value="" disabled>
                      Internet Connection
                    </option>
                    {INTERNET_CONNECTION.map((item) => (
                      <option value={item.label}>{item.value}</option>
                    ))}
                  </select>

                  {errors.internet_connection && (
                    <p className="text-star_color text-sm">
                      {errors.internet_connection}
                    </p>
                  )}
                </div>

                <div className="relative">
                  <label htmlFor="computer_system" className="mb-1 font-md block font-semibold capitalize">
                    Computer System <span className="text-star_color">*</span>
                  </label>
                  <select
                    id="computer_system"
                    name="computer_system"
                    value={formValues.computer_system}
                    onChange={(e) => handleChange(e, "other")}
                    className="form-select p-2 border border-gray-300 rounded w-full"
                  >
                    <option value="" disabled>
                      Computer System
                    </option>
                    {INTERNET_CONNECTION.map((item) => (
                      <option value={item.label}>{item.value}</option>
                    ))}
                  </select>
                  {errors.computer_system && (
                    <p className="text-star_color text-sm">
                      {errors.computer_system}
                    </p>
                  )}
                </div>

                <div className="relative">
                  <label htmlFor="staff_required" className="mb-1 font-md block font-semibold capitalize">
                    Office Staff Required <span className="text-star_color">*</span>
                  </label>
                  <select
                    id="staff_required"
                    name="staff_required"
                    value={formValues.staff_required}
                    onChange={(e) => handleChange(e, "other")}
                    className="form-select p-2 border border-gray-300 rounded w-full"
                  >
                    <option value="" disabled>
                      Office Staff
                    </option>
                    {INTERNET_CONNECTION.map((item) => (
                      <option value={item.label}>{item.value}</option>
                    ))}
                  </select>

                  {errors.staff_required && (
                    <p className="text-star_color text-sm">
                      {errors.staff_required}
                    </p>
                  )}
                </div>
              </div>
              {/* Brand training Details */}
              <div className="mb-8 mt-5">
                <h3 className="text-2xl font-lg text-text_color mt-3 font-semibold border-b border-[#b9b9b9] pb-2 mb-4">
                  Brand Training Details
                </h3>
                <div className="flex flex-col md:flex-row gap-4 mt-3">
                  <div className="flex-1">
                    <label
                      htmlFor="field_assistance"
                      className="mb-1 font-md block font-semibold capitalize"
                    >
                      Field Assistance Available for Brand
                      <span className="text-star_color">*</span>
                    </label>
                    <select
                      id="field_assistance"
                      name="field_assistance"
                      value={formValues.field_assistance}
                      onChange={(e) => handleChange(e, "other")}
                      className="form-select p-2 border border-gray-300 rounded w-full"
                    >
                      <option value="" disabled>
                        Field Assistance
                      </option>
                      {INTERNET_CONNECTION.map((item) => (
                        <option value={item.label}>{item.value}</option>
                      ))}
                    </select>
                    {errors.field_assistance && (
                      <p className="text-star_color text-sm">
                        {errors.field_assistance}
                      </p>
                    )}
                  </div>
                  <div className="flex-1">
                    <label
                      htmlFor="training_programme"
                      className="mb-1 font-md block font-semibold capitalize"
                    >
                      Brand Training Programme
                      <span className="text-star_color">*</span>
                    </label>
                    <select
                      id="training_programme"
                      name="training_programme"
                      value={formValues.training_programme}
                      onChange={(e) => handleChange(e, "other")}
                      className="form-select p-2 border border-gray-300 rounded w-full"
                    >
                      <option value="" disabled>
                        Brand Training
                      </option>
                      {INTERNET_CONNECTION.map((item) => (
                        <option value={item.label}>{item.value}</option>
                      ))}
                    </select>
                    {errors.training_programme && (
                      <p className="text-star_color text-sm">
                        {errors.training_programme}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label
                    htmlFor="detailed_operating"
                    className="mb-1 font-md block font-semibold capitalize"
                  >
                    Detailed Operating Manuals for Brand
                    <span className="text-star_color">*</span>
                  </label>
                  <select
                    id="detailed_operating"
                    name="detailed_operating"
                    value={formValues.detailed_operating}
                    onChange={(e) => handleChange(e, "other")}
                    className="form-select p-2 border border-gray-300 rounded w-full"
                  >
                    <option value="" disabled>
                      Detailed Operating
                    </option>
                    {INTERNET_CONNECTION.map((item) => (
                      <option value={item.label}>{item.value}</option>
                    ))}
                  </select>
                  {errors.detailed_operating && (
                    <p className="text-star_color text-sm">
                      {errors.detailed_operating}
                    </p>
                  )}
                </div>
                <div className="relative">
                  <label htmlFor="ITSystems" className="mb-1 font-md block font-semibold capitalize">
                    Need of IT Systems
                    <span className="text-star_color">*</span>
                  </label>
                  <select
                    id="ITSystems"
                    name="it_system"
                    value={formValues.it_system}
                    onChange={(e) => handleChange(e, "other")}
                    className="form-select p-2 border border-gray-300 rounded w-full"
                  >
                    <option value="" disabled>
                      IT Systems
                    </option>
                    {INTERNET_CONNECTION.map((item) => (
                      <option value={item.label}>{item.value}</option>
                    ))}
                  </select>

                  {errors.it_system && (
                    <p className="text-star_color text-sm">{errors.it_system}</p>
                  )}
                </div>
              </div>

              {/* {Brand Website Detail} */}
              <div className="mb-3">
                <h3 className="text-2xl font-lg text-text_color mt-3 font-semibold border-b border-[#b9b9b9] pb-2 mb-4">
                  Brand Website Detail
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
                  <div className="flex-1">
                    <label htmlFor="Website" className="mb-1 font-md block font-semibold capitalize">
                      Website <span className="text-star_color">*</span>
                    </label>
                    <input
                      type="text"
                      id="Website"
                      name="website"
                      value={formValues.website}
                      onChange={(e) => handleChange(e, "other")}
                      placeholder="Enter Website"
                      className="p-2 border border-gray-300 rounded w-full"
                    />
                    {errors.website && (
                      <p className="text-star_color text-sm">{errors.website}</p>
                    )}
                  </div>
                  <div className="">
                    <label htmlFor="country" className="mb-1 font-md block font-semibold capitalize">
                      Country <span className="text-star_color">*</span>
                    </label>
                    <select
                      id="country"
                      name="country"
                      value={formValues.country}
                      onChange={handleCountryChange}
                      className="form-select p-2 border border-gray-300 rounded w-full"
                    >
                      <option value="" disabled>
                        Select Country
                      </option>
                      {countries?.map((item) => (
                        <option value={item.name}>{item.name}</option>
                      ))}
                    </select>
                    {errors.country && (
                      <p className="text-star_color text-sm">{errors.country}</p>
                    )}
                  </div>
                  <div className="flex-1 ">
                    <label htmlFor="State" className="mb-1 font-md block font-semibold capitalize">
                      State <span className="text-star_color">*</span>
                    </label>

                    <select
                      type="text"
                      id="State"
                      name="state"
                      value={formValues.state}
                      onChange={handleStateChange}
                      placeholder="Enter State"
                      className="form-select p-2 border border-gray-300 rounded w-full"
                    >
                      <option value="" disabled>
                        Select State
                      </option>
                      {statedata?.map((item) => (
                        <option value={item.name} data-id={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    {errors.state && (
                      <p className="text-star_color text-sm">{errors.state}</p>
                    )}
                  </div>

                  <div className="">
                    <label htmlFor="city" className="mb-1 font-md block font-semibold capitalize">
                      City <span className="text-star_color">*</span>
                    </label>
                    <select
                      id="city"
                      name="city"
                      value={formValues.city}
                      onChange={(e) => handleChange(e, "other")}
                      className="form-select p-2 border border-gray-300 rounded w-full"
                    >
                      <option value="" disabled>
                        Select City
                      </option>
                      {citydata?.map((item) => (
                        <option value={item.name}>{item.name}</option>
                      ))}
                    </select>
                    {errors.city && (
                      <p className="text-star_color text-sm">{errors.city}</p>
                    )}
                  </div>
                </div>
              </div>
              {/* { Brand Other Detail} */}
              <div className="mt-4">
                <h3 className="text-2xl font-lg text-text_color mt-3 font-semibold border-b border-[#b9b9b9] pb-2 mb-4">
                  Brand Other Detail
                </h3>
                <div className="flex-1">
                  <label htmlFor="Franchiseterm" className="font-semibold">
                    Franchise Term<span className="text-star_color ">*</span>
                  </label>
                  <input
                    id="Franchiseterm"
                    name="franchise_term"
                    className="p-2 border border-gray-300 rounded w-full"
                    value={formValues.franchise_term}
                    onChange={(e) => handleChange(e, "other")}
                  />
                  {errors.franchise_term && (
                    <p className="text-star_color text-sm">
                      {errors.franchise_term}
                    </p>
                  )}
                </div>
                <div className="mt-3">
                  <p>
                    Have Standard Brand Agreement{" "}
                    <span className="text-star_color">*</span>
                  </p>
                  <div className="flex gap-28">
                    <div>
                      <input
                        type="radio"
                        id="agreementYes"
                        name="brand_agreement"
                        value="yes"
                        onChange={(e) => handleChange(e, "other")}
                      />
                      <label htmlFor="agreementYes" className="ml-2">
                        Yes
                      </label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="agreementNo"
                        name="brand_agreement"
                        value="no"
                        onChange={(e) => handleChange(e, "other")}
                      />
                      <label htmlFor="agreementNo" className="ml-2">
                        No
                      </label>
                    </div>
                  </div>
                  {errors.brand_agreement && (
                    <p className="text-star_color text-sm">
                      {errors.brand_agreement}
                    </p>
                  )}
                </div>
                <div className="mt-3">
                  <p>
                    Do You Give Master Franchise{" "}
                    <span className="text-star_color">*</span>
                  </p>
                  <div className="flex gap-28">
                    <div>
                      <input
                        type="radio"
                        id="agreementYes"
                        name="master_franchise"
                        value="yes"
                        onChange={(e) => handleChange(e, "other")}
                      />
                      <label htmlFor="agreementYes" className="ml-2">
                        Yes
                      </label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="agreementNo"
                        name="master_franchise"
                        value="no"
                        onChange={(e) => handleChange(e, "other")}
                      />
                      <label htmlFor="agreementNo" className="ml-2">
                        No
                      </label>
                    </div>
                  </div>
                  {errors.master_franchise && (
                    <p className="text-star_color text-sm">
                      {errors.master_franchise}
                    </p>
                  )}
                </div>
                <div class="mt-2">
                  <label
                    for="floatingTextarea2"
                    className=" py-2 text-gray-500 pointer-events-none"
                  >
                    Business Overview<span className="text-star_color">*</span>
                  </label>
                  <ReactQuill
                    className="block w-full rounded text-base text-gray-700 bg-white border border-gray-300  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Enter Business Overview"
                    id="businessOverviewEditor"
                    name="business_overview"
                    value={formValues.business_overview}
                    onChange={(value) => handleChange({ target: { name: 'business_overview', value } }, 'other')}
                  />
                  {errors.business_overview && (
                    <p className="text-star_color text-sm">
                      {errors.business_overview}
                    </p>
                  )}
                </div>
              </div>
              <div className="flex justify-around">


                <div className="w-[49%]">
                  <h2 className="mt-4 text-xl font-lg border-b font-semibold border-[#b9b9b9] pb-2">Upload Logo</h2>
                  <div className="mt-4">
                    <label htmlFor="logo" className="form-label font-semibold">
                      Upload Logo <span className="text-star_color">*</span>
                    </label>
                    <span className="block text-sm text-gray-600 mb-2">
                      Logo must be equal to or less than 20KB. Allowed formats: <b>png, jpeg, jpg, webp</b>.
                    </span>
                    <input
                      className="form-control border p-2 rounded bg-white"
                      type="file"
                      id="logo"
                      name="upload_logo"
                      accept=".png, .jpeg, .jpg, .webp"
                      onChange={(e) => {
                        handleChange(e, "logo");
                        setFormValues({ ...formValues, upload_logo: e.target.files[0] });
                      }}
                    />
                    {errors.upload_logo && (
                      <p className="text-star_color text-sm">{errors.upload_logo}</p>
                    )}
                  </div>

                </div>
                <div className="mt-4 w-[49%]">
                  <h2 className="text-xl font-lg border-b font-semibold border-[#b9b9b9] pb-2">Upload Banner</h2>
                  <div class="mt-4 w-full">
                    <label for="bannarlogo" className="form-label font-semibold">
                      Upload Banner {" "}
                      <span className="text-star_color">*</span>
                    </label>
                    <span className="block text-sm text-gray-600 mb-2">
                      Banner must be equal to or less than 500KB. Allowed formats: <b>png, jpeg, jpg, webp</b>.
                    </span>
                    <input
                      class="form-control border p-2 rounded bg-white"
                      type="file"
                      id="bannarlogo"
                      name="upload_banner"
                      accept=".png, .jpeg, .jpg, .webp"
                      onChange={(e) => { handleChange(e, "banner"); setFormValues({ ...formValues, upload_banner: e.target.files[0] }) }}
                    />
                    {errors.upload_banner && (
                      <p className="text-star_color text-sm">
                        {errors.upload_banner}
                      </p>
                    )}
                  </div>
                </div>
              </div>


              <div className="mt-4">
                <div>
                  <input
                    type="checkbox"
                    id="agreementNo"
                    name="terms_conditions"
                    value={formValues?.terms_conditions ? true : false}
                    checked={formValues?.terms_conditions}
                    onChange={(e) => handleChange(e, "other")}
                    onBlur={handleBlur}
                  />
                  <label htmlFor="agreementNo" className="ml-4 font-sm text-sm">
                    I/We have carefully read and agree to the{" "}
                    <span className="text-primaryColor">Terms & Conditions.</span>
                  </label>
                  {errors.terms_conditions
                    && (
                      <p className="text-star_color text-sm">
                        {errors.terms_conditions}
                      </p>)}
                </div>

              </div>
              <div className="flex justify-center items-center">
                <button
                  type="submit"
                  className="bg-primaryColor text-white p-2 rounded mt-5 mb-3 w-[30%]"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="flex-[0_0_20%] bg-[#f9f8f8] [box-shadow:inset_0_0px_0px_rgba(0,_0,_0,_.075),_0_0_0px_rgb(0_0_0_/_20%)]  lg:p-0 p-1 rounded-lg w-full mx-auto">

          <div className="bg-white p-2 mb-3 max-w-[335px]">
            {advertisementData
              ?.filter((item) => ['SideBanner1'].includes(item?.category))
              ?.map((filteredItem) => (
                <a
                  key={filteredItem?.index}
                  href={filteredItem?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img key={filteredItem?.id} src={filteredItem?.image || "https://via.placeholder.com/150/FFFFFF/FFFFFF?text=No+Image"} alt={filteredItem} className="" />
                </a>
              ))}
          </div>
          <div className="bg-white p-2 mb-3 max-w-[335px]">
            {advertisementData
              ?.filter((item) => ['SideBanner2'].includes(item?.category))
              ?.map((filteredItem) => (
                <a
                  key={filteredItem?.index}
                  href={filteredItem?.url}
                  target="_blank"
                  rel="noopener noreferrer"

                >
                  <img key={filteredItem?.id} src={filteredItem?.image || "https://via.placeholder.com/150/FFFFFF/FFFFFF?text=No+Image"} alt={filteredItem} className="" />
                </a>
              ))}
          </div>
          <div className="bg-white p-2 mb-3 max-w-[335px]">
            {advertisementData
              ?.filter((item) => ['SideBanner3'].includes(item?.category))
              ?.map((filteredItem) => (
                <a
                  key={filteredItem?.index}
                  href={filteredItem?.url}
                  target="_blank"
                  rel="noopener noreferrer"

                >
                  <img key={filteredItem?.id} src={filteredItem?.image || "https://via.placeholder.com/150/FFFFFF/FFFFFF?text=No+Image"} alt={filteredItem} className="" />
                </a>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Franchisor;